export const COUNTRY_POSTAL = {
  US: { postal_label: "ZIP Code", postal_example: "90001" },
  GB: { postal_label: "Postcode", postal_example: "SW1A 1AA" },
  IE: { postal_label: "Eircode", postal_example: "D02 X285" },
  GR: { postal_label: "Ταχυδρομικό Κώδικα", postal_example: "105 58" },
  SE: { postal_label: "Postnummer", postal_example: "114 55" }
};
